import { useState, useRef } from 'react'
import { WarningTriangle } from '../../../icons'
import type { Deviation } from '../../../../../../../types'

export function CarParkTableDeviation({
  deviations,
  type = 'danger',
}: {
  deviations: Deviation[]
  type?: 'danger' | 'warning'
}) {
  const [hovered, setHovered] = useState(false)
  const [tooltipPosition, setTooltipPosition] = useState({ top: 0, left: 0 })
  const iconRef = useRef<HTMLSpanElement>(null)

  const handleMouseEnter = () => {
    if (iconRef.current) {
      const rect = iconRef.current.getBoundingClientRect()
      setTooltipPosition({
        top: rect.top - 10,
        left: rect.left - 100,
      })
    }
    setHovered(true)
  }

  return (
    <>
      <span
        ref={iconRef}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={() => setHovered(false)}
        className={`cursor-pointer ${type === 'danger' ? 'text-old-content-danger' : 'text-old-warning'}`}
      >
        <WarningTriangle />
      </span>

      {hovered && (
        <div
          className="fixed z-[80] max-w-[200px] p-2 text-xs text-white bg-gray-800 rounded-md shadow-lg"
          style={{
            top: `${tooltipPosition.top}px`,
            left: `${tooltipPosition.left}px`,
            transform: 'translateY(-100%)',
          }}
        >
          {deviations.map((item, index: number) => {
            return <p key={index}>- {item.description}</p>
          })}
        </div>
      )}
    </>
  )
}
